import { AbstractCommand } from 'src/models/command';
import { Theme } from 'src/models/userInterfaceSettings';

class CreateANewColorSchemeCommand extends AbstractCommand {
	readonly name = 'IFS_Core_Command_Commands_CreateANewColorSchemeCommand';

	public constructor(name: string, scheme: Theme) {
		super();
		this.parameters = {
			name: name,
			scheme: scheme,
		};
	}
}

export { CreateANewColorSchemeCommand };
